import { Bag } from "@repo/apis/bag";
import type { BagSdkConfig } from "../sdk";
import { cache } from "./cache";

export const handleApiInteractionSuccess = async (
  config: BagSdkConfig,
  { bag, sessionToken }: { bag: Bag; sessionToken: string },
): Promise<void> => {
  await cache.put(config, { bag, sessionToken });
};
